import { Calendar as CalendarIcon, Sun, Moon } from 'lucide-react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Calendar } from '../ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { cn } from '../../lib/utils';
import { format } from 'date-fns';

export const DateStep = ({
  formData,
  updateFormData,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  templateDuration,
}) => (
  <div className="space-y-6">
    <div className="flex items-center gap-3 mb-6">
      <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-ocean to-gold flex items-center justify-center text-white shadow-lg">
        <CalendarIcon className="w-6 h-6" />
      </div>
      <div>
        <h3 className="text-xl font-semibold text-ocean">When are you traveling?</h3>
        <p className="text-ocean/70 text-sm">Pick your travel dates{templateDuration ? ` (Template: ${templateDuration} days)` : ''}</p>
      </div>
    </div>
    <div className="grid md:grid-cols-2 gap-6">
      <div className="bg-gradient-to-br from-ocean/10 to-sky/10 p-5 rounded-xl border border-ocean/20 backdrop-blur-sm">
        <Label className="text-ocean font-medium flex items-center gap-2">
          <Sun className="w-4 h-4 text-gold" /> Start Date
        </Label>
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="outline"
              className={cn('w-full justify-start text-left font-normal mt-2 h-12 bg-white/70',
                !startDate && 'text-ocean/50')}
              data-testid="start-date-btn">
              <CalendarIcon className="mr-2 h-5 w-5 text-ocean" />
              {startDate ? format(startDate, 'PPP') : 'Pick a date'}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar mode="single" selected={startDate}
              onSelect={(date) => {
                setStartDate(date);
                if (date) {
                  updateFormData('start_date', format(date, 'yyyy-MM-dd'));
                  if (templateDuration && !endDate) {
                    const end = new Date(date);
                    end.setDate(end.getDate() + templateDuration - 1);
                    setEndDate(end);
                    updateFormData('end_date', format(end, 'yyyy-MM-dd'));
                  }
                }
              }}
              disabled={(date) => date < new Date()} initialFocus />
          </PopoverContent>
        </Popover>
      </div>
      <div className="bg-gradient-to-br from-gold/10 to-sky/10 p-5 rounded-xl border border-gold/20 backdrop-blur-sm">
        <Label className="text-ocean font-medium flex items-center gap-2">
          <Moon className="w-4 h-4 text-ocean" /> End Date
        </Label>
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="outline"
              className={cn('w-full justify-start text-left font-normal mt-2 h-12 bg-white/70',
                !endDate && 'text-ocean/50')}
              data-testid="end-date-btn">
              <CalendarIcon className="mr-2 h-5 w-5 text-gold" />
              {endDate ? format(endDate, 'PPP') : 'Pick a date'}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar mode="single" selected={endDate}
              onSelect={(date) => { setEndDate(date); if (date) updateFormData('end_date', format(date, 'yyyy-MM-dd')); }}
              disabled={(date) => date < (startDate || new Date())} initialFocus />
          </PopoverContent>
        </Popover>
      </div>
    </div>
  </div>
);
